import { getSVG } from '@/components/Common/styles/mixins';
import clsx from 'clsx';
import React, { useState, useRef } from 'react';

import styles from './CoinAccordion.module.scss';

interface ICoinAccordionProps {
  title: React.ReactNode;
  contents: React.ReactNode;
  opened?: boolean;
  headerClassName?: string;
  bodyClassName?: string;
}

const CoinAccordion: React.FC<ICoinAccordionProps> = ({
  title,
  contents,
  opened = true,
  headerClassName,
  bodyClassName,
}) => {
  const ref = useRef(null);
  const [isOpened, setIsOpened] = useState(opened);

  return (
    <article className={styles.accordion}>
      <div
        ref={ref}
        onClick={() => setIsOpened((isOpened) => !isOpened)}
        className={clsx(styles.accordionHeader, headerClassName)}
      >
        <div>{title}</div>
        <img
          src={
            isOpened
              ? getSVG('/static/images/icon-arrow-up-black-line-2.svg')
              : getSVG('/static/images/icon-arrow-drop-black-line-2.svg')
          }
        />
      </div>
      <div className={clsx(styles.accordionBody, !isOpened && styles.collapsed, bodyClassName)}>
        <div>{contents}</div>
      </div>
    </article>
  );
};

export default CoinAccordion;
